import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createSurveyQuestion } from "../../../api/surveyQuestion.api";
import ErrorResponse from "../../../components/ErrorResponse";
import SurveyQuestionEditor from "../../../components/homepage/survey-question/SurveyQuestionEditor";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { ISurveyQuestionReq } from "../../../models/surveyQuestion.model";

const SurveyQuestionCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push('/homepage/survey-question');
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: ISurveyQuestionReq) => {
    submitExecute(createSurveyQuestion(data));
  }

  return (
    <div className="content scrollbar">
      {submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.surveyQuestion.title2')}
      />
      <SurveyQuestionEditor
        submit={submit}
      />
    </div>
  );
}

export default SurveyQuestionCreate;
